export default __webpack_public_path__ + "static/hero_bg-b3327ae3609c725214bce63478b379a0.jpg";